import styled from "styled-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { KeywordsGroupEditorModal } from "../../../../keyword-analysis/KeywordsGroupEditorModal";
import type { FC } from "react";
import { useState } from "react";
import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";
import { StyledBanner } from "app/components/banner/StyledBanner";
import { allTrackers } from "app/services/track/track";

const i18n = i18nFilter();

const Banner = styled(StyledBanner.Banner)`
    margin-bottom: 24px;
`;

interface AutoCreateKeywordGroupBannerProps {
    keyword: string;
    shouldShowBanner: boolean;
    onSave?: (modifiedGroup: IUserKeywordGroup) => void;
}

export const AutoCreateKeywordGroupBanner: FC<AutoCreateKeywordGroupBannerProps> = ({
    keyword,
    shouldShowBanner,
    onSave,
}) => {
    const [isAutoCreateModalOpen, setIsAutoCreateModalOpen] = useState(false);

    const openKeywordGroupCreationModal = () => {
        setIsAutoCreateModalOpen(true);
        allTrackers.dispatchTrackEvent("Button", "click", "Auto Create KW Lists CTA clicked/Banner");
    };

    return (
        shouldShowBanner && (
            <>
                <Banner
                    title={
                        <StyledBanner.TitleContainer>
                            <StyledBanner.Title>
                                keyword.analysis.auto.create.keyword.group.banner.title
                            </StyledBanner.Title>
                        </StyledBanner.TitleContainer>
                    }
                    subtitle={
                        <StyledBanner.Subtitle>
                            keyword.analysis.auto.create.keyword.group.banner.subtitle
                        </StyledBanner.Subtitle>
                    }
                    buttonText={i18n("listItemKeyword.auto.create.keyword.list.button")}
                    buttonIconName="wand"
                    buttonType="primary"
                    onButtonClick={openKeywordGroupCreationModal}
                    iconImagePath={AssetsService.assetUrl("/images/clicks-positive.svg")}
                    iconImageWidth={56}
                    iconImageHeight={56}
                />
                <KeywordsGroupEditorModal
                    onClose={() => {
                        setIsAutoCreateModalOpen(false);
                    }}
                    open={isAutoCreateModalOpen}
                    seedKeyword={keyword}
                    onSave={onSave}
                />
            </>
        )
    );
};
